/* eslint-disable @typescript-eslint/no-explicit-any */
import { getToken } from 'features/common'
import { QueryParameters } from '@deck.gl/carto'
import { SQLResponse } from '../types'
import { query, SourceOptionalOptions } from '@carto/api-client'
import settings from 'settings'

type SendSQLRequestOptions = {
  connection: string
  query: string
  extraParams?: Record<string, any>
  queryParameters?: QueryParameters
  refresh?: boolean
  signal?: AbortSignal
  headers?: SourceOptionalOptions['headers']
  localCache?: SourceOptionalOptions['localCache']
  maxLengthURL?: number
}

export const sendSQLRequest = async ({
  connection,
  query: sqlQuery,
  extraParams = {},
  queryParameters,
  refresh,
  signal,
  headers,
  localCache,
  maxLengthURL
}: SendSQLRequestOptions) => {
  const extraHeaders = refresh ? { 'Cache-Control': 'no-cache' } : null
  localCache = refresh ? { cacheControl: ['no-cache', 'no-store'] } : localCache
  if (!sqlQuery) {
    return {
      rows: [],
      schema: [],
      meta: {
        cacheHit: false,
        location: '',
        totalBytesProcessed: 0
      }
    }
  }

  return (await query({
    accessToken: await getToken(),
    apiBaseUrl: settings.apiBaseUrl,
    connectionName: connection,
    sqlQuery,
    queryParameters,
    internalParameters: extraParams,
    headers: {
      ...extraHeaders,
      ...headers
    },
    localCache,
    maxLengthURL,
    signal
  })) as unknown as SQLResponse // TODO: check if we should maintain this type or refactor more to use the QueryResult type
}

export const sendSQLPostRequest = async (params: SendSQLRequestOptions) => {
  return sendSQLRequest({
    ...params,
    maxLengthURL: 1 // force POST request with URL length check
  })
}

export const sendSQLRequestWithRetries = async (retry = 0, args: SendSQLRequestOptions) => {
  let lastError
  for (let i = 0; i <= retry; i++) {
    try {
      return sendSQLRequest(args)
    } catch (error) {
      lastError = error
    }
  }
  throw lastError
}
